import { Edge } from "@xyflow/react";
import { v4 as uuidv4 } from "uuid";

// React Flow looks edges up by id, so two edges sharing one draw a single line
// while both handles still show as connected. Ids built from just the node ids
// collide when two handles of one node lead to the same target, so every new
// edge gets a uuid.
export function createSequenceEdgeId(source: string, target: string): string {
  return `e-${source}-${target}-${uuidv4()}`;
}

/**
 * Gives every edge after the first with a repeated id a fresh one. Returns the
 * input array untouched when the ids are already unique.
 */
export function withUniqueEdgeIds(edges: Edge[]): Edge[] {
  const seenIds = new Set<string>();
  let hasDuplicates = false;

  const uniqueEdges = edges.map((edge) => {
    if (!seenIds.has(edge.id)) {
      seenIds.add(edge.id);
      return edge;
    }

    hasDuplicates = true;
    const id = createSequenceEdgeId(edge.source, edge.target);
    seenIds.add(id);
    return { ...edge, id };
  });

  return hasDuplicates ? uniqueEdges : edges;
}
